<template>
  <svg
    class="step"
    width="58px"
    height="29px"
    viewBox="1753 1162 58 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 3.8.3 (29802) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs/>
    <g
      id="Two"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      transform="translate(1753.000000, 1162.000000)"
    >
      <path
        d="M0,0 L47,0 L56.5285516,12.8928447 C57.1845443,13.7804521 57.1849069,15.2190573 56.5285516,16.1071553 L47,29 L0,29 L0,0 Z"
        id="Rectangle-55"
        fill="#4990E2"
      />
      <path
        d="M15.952,12.288 C17.356,9.714 20.182,11.55 18.472,13.476 L13.288,19.308 L14.098,20.982 L22.306,20.982 L22.306,17.922 L19.426,17.922 L17.932,18.228 L20.74,15.564 C21.892,14.484 22.324,13.188 22.324,12 C22.324,10.002 20.866,8.076 18.058,8.076 C16.312,8.076 14.584,8.976 13.54,10.974 L15.952,12.288 Z"
        id="2"
        fill="#FFFFFF"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'StepTwoIcon'
}
</script>
